// extracted by mini-css-extract-plugin
export default {"invalidInput":"ErrorLabel_invalidInput__Fe-pq","yellowLabel":"ErrorLabel_yellowLabel__vv5Oo","greenLabel":"ErrorLabel_greenLabel__9neqT"};